/**
 * Mirror the resolved reader theme onto the document element.
 *
 * The palettes answer on `:root` alone, so the reveal (`html.ready`) paints
 * html and body with the theme's own page surface instead of the light default
 * every other theme would flash through the fade-in. The reader element
 * inherits those values from here.
 *
 * Takes the resolved theme (never 'system'), the same value the reader element
 * carries.
 */
export default function applyThemeToDocument(theme) {
    if (!theme) {
        return;
    }

    document.documentElement.dataset.theme = theme;
}
